export default __webpack_public_path__ + "static/media/safa.9934466b.jpg";